import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  TuiCheckboxBlockModule,
  TuiCheckboxLabeledModule,
  TuiCheckboxModule
} from "@taiga-ui/kit";
import { KwikUISafeHtmlPipeModule } from "../../../pipes/safe-html/safe-html.module";
import { KwikUICheckboxComponent } from "./checkbox.component";

@NgModule({
  declarations: [KwikUICheckboxComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiCheckboxModule,
    TuiCheckboxBlockModule,
    TuiCheckboxLabeledModule,
    KwikUISafeHtmlPipeModule
  ],
  exports: [KwikUICheckboxComponent]
})
export class KwikUICheckboxModule {}
